export default "__VITE_ASSET__Cx$gyJOL__"